import { render, staticRenderFns } from "./exam_detail.vue?vue&type=template&id=30541abb&scoped=true&"
import script from "./exam_detail.vue?vue&type=script&lang=js&"
export * from "./exam_detail.vue?vue&type=script&lang=js&"
import style0 from "./exam_detail.vue?vue&type=style&index=0&id=30541abb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30541abb",
  null
  
)

export default component.exports